import React from "react";
// import { Component } from "react";
import { TRANSPOTER_GSTIN } from "../config/config.js";
import "./ComponentToPrint.css";
import { groupInfo } from "../config/Biltyform.js";
import { TRANSPORTER_NAME } from "../config/config";
let delivery_at = ["DOOR_DLY", "GODOWN_TPT", "PRIORITY"];
let dict = {};

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let total_items = 0;
    for (let i = 0; i < this.props.fields.item_in.length; i++) {
      total_items += Number(this.props.fields.item_in[i]["pkgs"]);
    }
    var packing_type = [
      "Carton",
      "Cargo",
      "Bag",
      "Bundle",
      "Bucket",
      "Box",
      "Roll",
      "Drum",
      "Loose",
      "Kantan Pack",
      "Plastic Pack",
      "Pipe",
      "Peti",
      "Carboy",
      "Barrel",
      "Tin",
    ];
    return (
      <div id="bilty-print">
        <div id="main">
          <div id="lrno-text">LR No. : </div>
          <div id="r1col2-lrno">
            <label id="r1col2-lrno-label">{this.props.fields.bilty_no}</label>
          </div>

          {/* <div id="r1col2-date">
            <label id="r1col2-date-label">
              {String(this.props.fields.input_date.getUTCDate()) +
                "/" +
                String(this.props.fields.input_date.getUTCMonth() + 1) +
                "/" +
                String(this.props.fields.input_date.getUTCFullYear()) +
                " " +
                new Date().getHours() +
                ":" +
                new Date().getMinutes()}
            </label>
          </div> */}

          <div id="from-text">From : </div>
          <div id="r1col2-from">
            <label id="r1col2-from-label">
              {this.props.fields.station_from_name} &nbsp;
              {this.props.fields.station_from_mobile}
            </label>
          </div>
          <div id="to-text">To :</div>
          <div id="r1col2-to">
            <label id="r1col2-to-label">
              {this.props.fields.station_to_name} &nbsp;
              {this.props.fields.station_to_mobile}
            </label>
          </div>
          <div id="consignor-text">Consignor :</div>
          <div id="r2col1">
            <label id="consignor"> {this.props.fields.consignor_name}</label>
            &nbsp; &nbsp; &nbsp; &nbsp;
            {/* <label id="consignorGst"> {this.props.fields.consignor_gst} </label> */}
          </div>
          <div id="conignor-GST-text">GST No. :</div>

          <div id="consignor-m-text">
            M. :{this.props.fields.consignor_mobile}
          </div>
          <div id="conignee-text">Consignee : </div>

          <div id="r2col2">
            <label id="consignee"> {this.props.fields.consignee_name}</label>
            &nbsp; &nbsp; &nbsp; &nbsp;
            {/* <label > </label> */}
          </div>
          <div id="consigneetGSTNo">GST No. :</div>
          <div id="consigneeGst">{this.props.fields.consignee_gst}</div>
          <div id="M-text">M. :{this.props.fields.consignee_mo_no}</div>

          <div id="consignor-gst-value"> {this.props.fields.consignor_gst}</div>
          <div id="table-container">
            <div class="item1">Article</div>
            <div class="item2">Description</div>
            <div class="item3">Weight</div>
            <div class="item4">Freight</div>
            <div class="item5">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.freight}
              </label>
            </div>
            <div class="item6">Date</div>
            <div class="item7">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.pkgs} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div class="item8">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.item_name} &nbsp;
                    {"(" + packing_type[d.packing_type - 1] + ")"} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div class="item9">
              <label>{this.props.fields.charge_weight}</label>
            </div>
            <div class="item10">B.C.</div>
            <div class="item11">
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? 0
                : this.props.fields.bilty_charge}
            </div>
            <div class="item12">
            <label id="r1col2-date-label">
              {
                String(this.props.fields.input_date.getUTCDate()) +
                "/" +
                String(this.props.fields.input_date.getUTCMonth() + 1) +
                "/" +
                String(this.props.fields.input_date.getUTCFullYear()) +
                " " +
                new Date(new Date().getTime() - 5.5 * 60 * 60 * 1000).toLocaleTimeString('en-IN', {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false
                })
              }
            </label>
            </div>
            <div class="item13">Del. Charge</div>
            <div class="item14">
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? 0
                : this.props.fields.door_del_charge}
            </div>
            <div class="item15">Delivery at</div>
            <div class="item16">L.C. Charge</div>
            <div class="item17">
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? 0
                : this.props.fields.lc_charge}
            </div>
            <div class="item18">
              <label id="owner-risk-mr-no-label">
                {delivery_at[this.props.fields.delivery_dest_type - 1]}
              </label>
            </div>
            <div class="item19">
              Consignee <br /> Copy
            </div>
            <div class="item20">Hamali</div>
            <div class="item21">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.hamali}
              </label>
            </div>
            <div class="item22">Other</div>
            <div class="item23">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.other_amount}
              </label>
            </div>
            <div class="item24">
              Payment <br /> Mode
            </div>
            <div class="item25">
              Owner's <br />
              Risk
            </div>
            <div class="item28">{total_items}</div>
            <div class="item29">
              EWAYBILL-
              {this.props.fields.eway_bill_no[0].eway_bill_no === ""
                ? 0
                : this.props.fields.eway_bill_no.length}{" "}
              &nbsp; &nbsp; V. No.: {this.props.fields.vehicle_no}
            </div>
            <div class="item30">Grand Total</div>
            <div class="item31">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.total_amount}
              </label>
            </div>
            <div class="item32">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? "TBB"
                  : groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                      this.props.fields.pay_type - 1
                    ].label.toUpperCase()}
              </label>
            </div>
            <div class="item33">
              <div id="r3-private-marka" class="left-div">
                <label>P.M.: {this.props.fields.private_marka_no}</label>
              </div>
              <section>
                <div class="left-div">
                  <label>Remarks: {this.props.fields.remarks}</label>
                </div>
                <div id="r3-value">
                  Invoice: {this.props.fields.goods_invoice_value}
                </div>
              </section>
            </div>

            {/* <div class="i1">pmode_val</div>
            <div class="i2">pmode_val</div>
            <div class="i3">pmode_val</div>
            <div class="i4">pmode_val</div>
            <div class="i5">pmode_val</div>
            <div class="i6">pmode_val</div>
            <div class="i7">pmode_val</div>
            <div class="i8">pmode_val</div> */}
            {/* <div id="r3-no-of-articles">
            <label>
              {this.props.fields.item_in.map((d) => (
                <React.Fragment>
                  {d.pkgs} <br></br>
                </React.Fragment>
              ))}
            </label>
          </div>
          <div id="r3-method-packaging">
            <label>
              {this.props.fields.item_in.map((d) => (
                <React.Fragment>
                  {packing_type[d.packing_type - 1]} <br></br>{" "}
                </React.Fragment>
              ))}
            </label>
          </div>
          <div id="r3-description">
            <label>
              {this.props.fields.item_in.map((d) => (
                <React.Fragment>
                  {d.item_name} <br></br>
                </React.Fragment>
              ))}
            </label>
          </div>
          <div id="r3-remarks">
            <label>{this.props.fields.remarks}</label>
          </div>
          <div id="delivery-at">
            <label id="owner-risk-mr-no-label">
              {delivery_at[this.props.fields.delivery_dest_type - 1]}
            </label>
          </div>
          <div id="r3-weight">
            <label>{this.props.fields.charge_weight}</label>
          </div>

          <div id="r3-freight">
            <label>
              {this.props.fields.freight}
            </label>
          </div>

          <div id="r3-hamali">
            <label>
              {this.props.fields.hamali}
            </label>
          </div>

          <div id="r3-pay-type">
            <label>
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? "TBB"
                : groupInfo["group-1"][3]["dropdown_items"][
                    this.props.fields.pay_type - 1
                  ].label.toUpperCase()}
            </label>
          </div>
          <div id="r3-charged">
            <label>{this.props.fields.charge_weight}</label>
          </div>
          <div id="r3-private-marka">
            <label>{this.props.fields.private_marka_no}</label>
          </div>

          <div id="r3-rate">
            <label>{this.props.fields.item_in[0].rate}</label>
          </div>
          <div id="r3-total-amount">
            <label>
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" ||
              groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.new_total_amount}
            </label>
          </div>
          <div id="r3-others">
            <label>
              {this.props.fields.other_amount}
            </label>
          </div>
          <div id="r3-bilty-charge">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.bilty_charge}
          </div>
          <div id="r3-collection">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.lc_charge}
          </div>
          <div id="r3-ddc">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.door_del_charge}
          </div>
          <div id="r3-cartage">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.cartage_charge}
          </div>
          <div id="r3-eway-bill">
            EWAYBILL-{this.props.fields.eway_bill_no[0]["eway_bill_no"]}
          </div>
          <div id="r3-value">{this.props.fields.goods_invoice_value}</div>
          <div id="r3-invoice-no">{this.props.fields.invoice_no}</div> */}
          </div>
        </div>
        <div id="main1">
          <div id="lrno-text">LR No. : </div>
          <div id="r1col2-lrno">
            <label id="r1col2-lrno-label">{this.props.fields.bilty_no}</label>
          </div>

          {/* <div id="r1col2-date">
            <label id="r1col2-date-label">
              {String(this.props.fields.input_date.getUTCDate()) +
                "/" +
                String(this.props.fields.input_date.getUTCMonth() + 1) +
                "/" +
                String(this.props.fields.input_date.getUTCFullYear()) +
                " " +
                new Date().getHours() +
                ":" +
                new Date().getMinutes()}
            </label>
          </div> */}

          <div id="from-text">From : </div>
          <div id="r1col2-from">
            <label id="r1col2-from-label">
              {this.props.fields.station_from_name} &nbsp;
              {this.props.fields.station_from_mobile}
            </label>
          </div>
          <div id="to-text">To :</div>
          <div id="r1col2-to">
            <label id="r1col2-to-label">
              {this.props.fields.station_to_name} &nbsp;
              {this.props.fields.station_to_mobile}
            </label>
          </div>
          <div id="consignor-text">Consignor :</div>
          <div id="r2col1">
            <label id="consignor"> {this.props.fields.consignor_name}</label>
            &nbsp; &nbsp; &nbsp; &nbsp;
            {/* <label id="consignorGst"> {this.props.fields.consignor_gst} </label> */}
          </div>
          <div id="conignor-GST-text">GST No. :</div>

          <div id="consignor-m-text">
            M. :{this.props.fields.consignor_mobile}
          </div>
          <div id="conignee-text">Consignee : </div>

          <div id="r2col2">
            <label id="consignee"> {this.props.fields.consignee_name}</label>
            &nbsp; &nbsp; &nbsp; &nbsp;
            {/* <label > </label> */}
          </div>
          <div id="consigneetGSTNo">GST No. :</div>
          <div id="consigneeGst">{this.props.fields.consignee_gst}</div>
          <div id="M-text">M. :{this.props.fields.consignee_mo_no}</div>

          <div id="consignor-gst-value"> {this.props.fields.consignor_gst}</div>
          <div id="table-container">
            <div class="item1">Article</div>
            <div class="item2">Description</div>
            <div class="item3">Weight</div>
            <div class="item4">Freight</div>
            <div class="item5">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.freight}
              </label>
            </div>
            <div class="item6">Date</div>
            <div class="item7">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.pkgs} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div class="item8">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.item_name} &nbsp;
                    {"(" + packing_type[d.packing_type - 1] + ")"} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div class="item9">
              <label>{this.props.fields.charge_weight}</label>
            </div>
            <div class="item10">B.C.</div>
            <div class="item11">
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? 0
                : this.props.fields.bilty_charge}
            </div>
            <div class="item12">
            <label id="r1col2-date-label">
              {
                String(this.props.fields.input_date.getUTCDate()) +
                "/" +
                String(this.props.fields.input_date.getUTCMonth() + 1) +
                "/" +
                String(this.props.fields.input_date.getUTCFullYear()) +
                " " +
                new Date(new Date().getTime() - 5.5 * 60 * 60 * 1000).toLocaleTimeString('en-IN', {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false
                })
              }
            </label>
            </div>
            <div class="item13">Del. Charge</div>
            <div class="item14">
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? 0
                : this.props.fields.door_del_charge}
            </div>
            <div class="item15">Delivery at</div>
            <div class="item16">L.C. Charge</div>
            <div class="item17">
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? 0
                : this.props.fields.lc_charge}
            </div>
            <div class="item18">
              <label id="owner-risk-mr-no-label">
                {delivery_at[this.props.fields.delivery_dest_type - 1]}
              </label>
            </div>
            <div class="item19">
              Delivery <br /> Copy
            </div>
            <div class="item20">Hamali</div>
            <div class="item21">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.hamali}
              </label>
            </div>
            <div class="item22">Other</div>
            <div class="item23">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.other_amount}
              </label>
            </div>
            <div class="item24">
              Payment <br /> Mode
            </div>
            <div class="item25">
              Owner's <br />
              Risk
            </div>
            <div class="item28">{total_items}</div>
            <div class="item29">
              EWAYBILL-
              {this.props.fields.eway_bill_no[0].eway_bill_no === ""
                ? 0
                : this.props.fields.eway_bill_no.length}{" "}
              &nbsp; &nbsp; V. No.: {this.props.fields.vehicle_no}
            </div>
            <div class="item30">Grand Total</div>
            <div class="item31">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.total_amount}
              </label>
            </div>
            <div class="item32">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? "TBB"
                  : groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                      this.props.fields.pay_type - 1
                    ].label.toUpperCase()}
              </label>
            </div>
            <div class="item33">
              <div id="r3-private-marka" class="left-div">
                <label>P.M.: {this.props.fields.private_marka_no}</label>
              </div>
              <section>
                <div class="left-div">
                  <label>Remarks: {this.props.fields.remarks}</label>
                </div>
                <div id="r3-value">
                  Invoice: {this.props.fields.goods_invoice_value}
                </div>
              </section>
            </div>

            {/* <div class="i1">pmode_val</div>
            <div class="i2">pmode_val</div>
            <div class="i3">pmode_val</div>
            <div class="i4">pmode_val</div>
            <div class="i5">pmode_val</div>
            <div class="i6">pmode_val</div>
            <div class="i7">pmode_val</div>
            <div class="i8">pmode_val</div> */}

            {/* <div id="r3-no-of-articles">
            <label>
              {this.props.fields.item_in.map((d) => (
                <React.Fragment>
                  {d.pkgs} <br></br>
                </React.Fragment>
              ))}
            </label>
          </div>
          <div id="r3-method-packaging">
            <label>
              {this.props.fields.item_in.map((d) => (
                <React.Fragment>
                  {packing_type[d.packing_type - 1]} <br></br>{" "}
                </React.Fragment>
              ))}
            </label>
          </div>
          <div id="r3-description">
            <label>
              {this.props.fields.item_in.map((d) => (
                <React.Fragment>
                  {d.item_name} <br></br>
                </React.Fragment>
              ))}
            </label>
          </div>
          <div id="r3-remarks">
            <label>{this.props.fields.remarks}</label>
          </div>
          <div id="delivery-at">
            <label id="owner-risk-mr-no-label">
              {delivery_at[this.props.fields.delivery_dest_type - 1]}
            </label>
          </div>
          <div id="r3-weight">
            <label>{this.props.fields.charge_weight}</label>
          </div>

          <div id="r3-freight">
            <label>
              {this.props.fields.freight}
            </label>
          </div>

          <div id="r3-hamali">
            <label>
              {this.props.fields.hamali}
            </label>
          </div>

          <div id="r3-pay-type">
            <label>
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? "TBB"
                : groupInfo["group-1"][3]["dropdown_items"][
                    this.props.fields.pay_type - 1
                  ].label.toUpperCase()}
            </label>
          </div>
          <div id="r3-charged">
            <label>{this.props.fields.charge_weight}</label>
          </div>
          <div id="r3-private-marka">
            <label>{this.props.fields.private_marka_no}</label>
          </div>

          <div id="r3-rate">
            <label>{this.props.fields.item_in[0].rate}</label>
          </div>
          <div id="r3-total-amount">
            <label>
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" ||
              groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.new_total_amount}
            </label>
          </div>
          <div id="r3-others">
            <label>
              {this.props.fields.other_amount}
            </label>
          </div>
          <div id="r3-bilty-charge">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.bilty_charge}
          </div>
          <div id="r3-collection">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.lc_charge}
          </div>
          <div id="r3-ddc">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.door_del_charge}
          </div>
          <div id="r3-cartage">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.cartage_charge}
          </div>
          <div id="r3-eway-bill">
            EWAYBILL-{this.props.fields.eway_bill_no[0]["eway_bill_no"]}
          </div>
          <div id="r3-value">{this.props.fields.goods_invoice_value}</div>
          <div id="r3-invoice-no">{this.props.fields.invoice_no}</div> */}
          </div>
        </div>
        <div id="main2">
          <div id="lrno-text">LR No. : </div>
          <div id="r1col2-lrno">
            <label id="r1col2-lrno-label">{this.props.fields.bilty_no}</label>
          </div>

          {/* <div id="r1col2-date">
            <label id="r1col2-date-label">
              {String(this.props.fields.input_date.getUTCDate()) +
                "/" +
                String(this.props.fields.input_date.getUTCMonth() + 1) +
                "/" +
                String(this.props.fields.input_date.getUTCFullYear()) +
                " " +
                new Date().getHours() +
                ":" +
                new Date().getMinutes()}
            </label>
          </div> */}

          <div id="from-text">From : </div>
          <div id="r1col2-from">
            <label id="r1col2-from-label">
              {this.props.fields.station_from_name} &nbsp;
              {this.props.fields.station_from_mobile}
            </label>
          </div>
          <div id="to-text">To :</div>
          <div id="r1col2-to">
            <label id="r1col2-to-label">
              {this.props.fields.station_to_name} &nbsp;
              {this.props.fields.station_to_mobile}
            </label>
          </div>
          <div id="consignor-text">Consignor :</div>
          <div id="r2col1">
            <label id="consignor"> {this.props.fields.consignor_name}</label>
            &nbsp; &nbsp; &nbsp; &nbsp;
            {/* <label id="consignorGst"> {this.props.fields.consignor_gst} </label> */}
          </div>
          <div id="conignor-GST-text">GST No. :</div>

          <div id="consignor-m-text">
            M. :{this.props.fields.consignor_mobile}
          </div>
          <div id="conignee-text">Consignee : </div>

          <div id="r2col2">
            <label id="consignee"> {this.props.fields.consignee_name}</label>
            &nbsp; &nbsp; &nbsp; &nbsp;
            {/* <label > </label> */}
          </div>
          <div id="consigneetGSTNo">GST No. :</div>
          <div id="consigneeGst">{this.props.fields.consignee_gst}</div>
          <div id="M-text">M. : {this.props.fields.consignee_mo_no}</div>

          <div id="consignor-gst-value"> {this.props.fields.consignor_gst}</div>
          <div id="table-container">
            <div class="item1">Article</div>
            <div class="item2">Description</div>
            <div class="item3">Weight</div>
            <div class="item4">Freight</div>
            <div class="item5">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.freight}
              </label>
            </div>
            <div class="item6">Date</div>
            <div class="item7">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.pkgs} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div class="item8">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.item_name} &nbsp;
                    {"(" + packing_type[d.packing_type - 1] + ")"} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div class="item9">
              <label>{this.props.fields.charge_weight}</label>
            </div>
            <div class="item10">B.C.</div>
            <div class="item11">
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? 0
                : this.props.fields.bilty_charge}
            </div>
            <div class="item12">
            <label id="r1col2-date-label">
              {
                String(this.props.fields.input_date.getUTCDate()) +
                "/" +
                String(this.props.fields.input_date.getUTCMonth() + 1) +
                "/" +
                String(this.props.fields.input_date.getUTCFullYear()) +
                " " +
                new Date(new Date().getTime() - 5.5 * 60 * 60 * 1000).toLocaleTimeString('en-IN', {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false
                })
              }
            </label>
            </div>
            <div class="item13">Del. Charge</div>
            <div class="item14">
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? 0
                : this.props.fields.door_del_charge}
            </div>
            <div class="item15">Delivery at</div>
            <div class="item16">L.C. Charge</div>
            <div class="item17">
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? 0
                : this.props.fields.lc_charge}
            </div>
            <div class="item18">
              <label id="owner-risk-mr-no-label">
                {delivery_at[this.props.fields.delivery_dest_type - 1]}
              </label>
            </div>
            <div class="item19">
              Consignor <br /> Copy
            </div>
            <div class="item20">Hamali</div>
            <div class="item21">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.hamali}
              </label>
            </div>
            <div class="item22">Other</div>
            <div class="item23">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.other_amount}
              </label>
            </div>
            <div class="item24">
              Payment <br /> Mode
            </div>
            <div class="item25">
              Owner's <br />
              Risk
            </div>
            <div class="item28">{total_items}</div>
            <div class="item29">
              EWAYBILL-
              {this.props.fields.eway_bill_no[0].eway_bill_no === ""
                ? 0
                : this.props.fields.eway_bill_no.length}{" "}
              &nbsp; &nbsp; V. No.: {this.props.fields.vehicle_no}
            </div>
            <div class="item30">Grand Total</div>
            <div class="item31">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? 0
                  : this.props.fields.total_amount}
              </label>
            </div>
            <div class="item32">
              <label>
                {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                  this.props.fields.pay_type - 1
                ].label.toUpperCase() == "TO BE BILLED"
                  ? "TBB"
                  : groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                      this.props.fields.pay_type - 1
                    ].label.toUpperCase()}
              </label>
            </div>
            <div class="item33">
              <div id="r3-private-marka" class="left-div">
                <label>P.M.: {this.props.fields.private_marka_no}</label>
              </div>
              <section>
                <div class="left-div">
                  <label>Remarks: {this.props.fields.remarks}</label>
                </div>
                <div id="r3-value">
                  Invoice: {this.props.fields.goods_invoice_value}
                </div>
              </section>
            </div>

            {/* <div class="i1">pmode_val</div>
            <div class="i2">pmode_val</div>
            <div class="i3">pmode_val</div>
            <div class="i4">pmode_val</div>
            <div class="i5">pmode_val</div>
            <div class="i6">pmode_val</div>
            <div class="i7">pmode_val</div>
            <div class="i8">pmode_val</div> */}

            {/* <div id="r3-no-of-articles">
            <label>
              {this.props.fields.item_in.map((d) => (
                <React.Fragment>
                  {d.pkgs} <br></br>
                </React.Fragment>
              ))}
            </label>
          </div>
          <div id="r3-method-packaging">
            <label>
              {this.props.fields.item_in.map((d) => (
                <React.Fragment>
                  {packing_type[d.packing_type - 1]} <br></br>{" "}
                </React.Fragment>
              ))}
            </label>
          </div>
          <div id="r3-description">
            <label>
              {this.props.fields.item_in.map((d) => (
                <React.Fragment>
                  {d.item_name} <br></br>
                </React.Fragment>
              ))}
            </label>
          </div>
          <div id="r3-remarks">
            <label>{this.props.fields.remarks}</label>
          </div>
          <div id="delivery-at">
            <label id="owner-risk-mr-no-label">
              {delivery_at[this.props.fields.delivery_dest_type - 1]}
            </label>
          </div>
          <div id="r3-weight">
            <label>{this.props.fields.charge_weight}</label>
          </div>

          <div id="r3-freight">
            <label>
              {this.props.fields.freight}
            </label>
          </div>

          <div id="r3-hamali">
            <label>
              {this.props.fields.hamali}
            </label>
          </div>

          <div id="r3-pay-type">
            <label>
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label.toUpperCase() == "TO BE BILLED"
                ? "TBB"
                : groupInfo["group-1"][3]["dropdown_items"][
                    this.props.fields.pay_type - 1
                  ].label.toUpperCase()}
            </label>
          </div>
          <div id="r3-charged">
            <label>{this.props.fields.charge_weight}</label>
          </div>
          <div id="r3-private-marka">
            <label>{this.props.fields.private_marka_no}</label>
          </div>

          <div id="r3-rate">
            <label>{this.props.fields.item_in[0].rate}</label>
          </div>
          <div id="r3-total-amount">
            <label>
              {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" ||
              groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.new_total_amount}
            </label>
          </div>
          <div id="r3-others">
            <label>
              {this.props.fields.other_amount}
            </label>
          </div>
          <div id="r3-bilty-charge">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.bilty_charge}
          </div>
          <div id="r3-collection">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.lc_charge}
          </div>
          <div id="r3-ddc">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.door_del_charge}
          </div>
          <div id="r3-cartage">
            {groupInfo["group-1"].find(item => item.name === "pay_type").dropdown_items[
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" ||
            groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? ""
              : this.props.fields.cartage_charge}
          </div>
          <div id="r3-eway-bill">
            EWAYBILL-{this.props.fields.eway_bill_no[0]["eway_bill_no"]}
          </div>
          <div id="r3-value">{this.props.fields.goods_invoice_value}</div>
          <div id="r3-invoice-no">{this.props.fields.invoice_no}</div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default ComponentToPrint;
